import baseAPI from "@/http";

const router = "api/geral/entidadeCertificadora";

export const entidadeCertificadoraAPI = {
  list: () => baseAPI.get(router)
};
